/**
 * Create the store with dynamic reducers
 */

import createRootReducer from './rootReduer';
import rootSaga from './rootSaga';
import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';

export function configureStore(initialState = {}) {
    const sagaMiddleware = createSagaMiddleware();

    // Create the store with middlewares
    // 1. sagaMiddleware: Makes redux-sagas work
    const middlewares = [sagaMiddleware];

    const enhancers = [applyMiddleware(...middlewares)];

    // Add redux devtools enhancer for non prod env
    const isChrome =
        /Chrome/.test(navigator.userAgent) &&
        /Google Inc/.test(navigator.vendor);
    if (
        process.env.NODE_ENV !== 'production' &&
        typeof window === 'object' &&
        window.__REDUX_DEVTOOLS_EXTENSION__ &&
        isChrome
    ) {
        const devToolsExtension =
            window.__REDUX_DEVTOOLS_EXTENSION__ &&
            window.__REDUX_DEVTOOLS_EXTENSION__();

        enhancers.push(devToolsExtension);
    }

    // Create store
    const store = createStore(
        createRootReducer(),
        initialState,
        compose(...enhancers)
    );

    // run sagaMiddleware
    sagaMiddleware.run(rootSaga);

    return store;
}

export default configureStore;
